export const CATEGORY_TO_SCHEMA = {
  AnimalsAccessories: { primary: 'PetStore' },
  'Medical-Accessories': { primary: 'MedicalBusiness' },
  'Spaces-Storage': { primary: 'SelfStorage' },
  'Recreational-Vehicles': { primary: 'RVDealer' },
  'RV-Trailers': { primary: 'AutoDealer' },
  'Photography-Video': { primary: 'ProfessionalService', additional: ['PhotographyBusiness'] },
  'People-Services': { primary: 'ProfessionalService' },
  Moving: { primary: 'MovingCompany' },
  'Sports-Recreation': { primary: 'SportsActivityLocation' },
  'Equipment-Tools': { primary: 'LocalBusiness', additional: ['RentalService'] },
  'Electronics-Furniture': { primary: 'Store' },
  'Fashion-Accessories': { primary: 'ClothingStore' },
  'Kids-Baby': { primary: 'Store' },
  'Toys-Games-Music-Books-Art': { primary: 'Store' },
  'Party-Event': { primary: 'EventService' },
  Miscellaneous: { primary: 'LocalBusiness' },
  'watercraft-accessories': { primary: 'SportsActivityLocation' },
};
